module.exports = __webpack_public_path__ + "static/media/additionButton.15b6531a.svg";